import { theme } from '@ahmdigital/ui';
import styled from 'styled-components';

const { media } = theme;

export const CoverContainer = styled.div`
  margin-bottom: 1.5rem;
  grid-template-columns: repeat(1, 1fr);
  display: grid;
  gap: 0.5rem;
`;

export const ContentWrapper = styled.div`
  @media (min-width: ${media.md}) {
    width: 21.5rem;
  }
`;
